<template>
  <div
      class="gjw-signin-page gjw-flex-container gjw-flex-column gjw-flex-horiz-center gjw-flex-verti-center"
  >
    <div class="sign-in-title">
      <img src="@/assets/img/logo.svg" height="32px" alt="" />
    </div>
    <iframe
        id="userInfoIframe"
        :src="iframeUrl"
        frameborder="0"
        width="500px"
        height="428px"
    >
    </iframe>
    <div>
      <img src="@/assets/img/zhiditu@2x.png" class="huo-dong-tu" @click="toHelp" alt="" />
    </div>
    <div class="footer-container" v-if="platform === 'web'">
      京ICP备10021606号-24 广联达科技股份有限公司旗下产品
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import checkLoginMixin from '@/mixins/checkLoginMixin'
import openUrlMixin from '@/mixins/openUrlMixin'
import Utils from '@/core/utils'
import jsonp from 'jsonp'

export default {
  mixins: [checkLoginMixin, openUrlMixin],
  computed: {
    ...mapGetters({
      user: 'user/user',
      platform: 'platform',
      getConfig: 'staticConfig/getConfig',
    }),
    iframeUrl() {
      return `${process.env.VUE_APP_GJW_PORTAL_URL}/signinForTeam?dest=${encodeURIComponent(window.location.href)}&platform=${this.platform}`
    },
    destination() {
      return this.$route.query.dest ? decodeURIComponent(this.$route.query.dest) : ''
    },
    introUrl() {
      const linkUrls = this.getConfig('linkUrls') || {}
      return linkUrls.introUrl || ''
    },
  },
  created() {
    this.checkSsoLogin()
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage, false)
  },
  beforeDestroy() {
    // 移除事件监听, 防止重复触发
    window.removeEventListener('message', this.receiveMessage, false)
  },
  methods: {
    ...mapActions({
      loadUserInfoBySso: 'user/loadUserInfoBySso',
    }),
    // 校验服务端是否通过sso登录
    checkSsoLogin() {
      if (this.platform === 'web' && !this.user.id) {
        const serviceKey = 'hK5hIYGSs7nglswQvmHnIbUWd6kyOtDe'
        const jsonpUrl = `${process.env.VUE_APP_GLODON_ACCOUNT_HOST}/user_ticket?service_key=${serviceKey}`
        jsonp(jsonpUrl,
          null,
          async (err, data) => {
            if (!err) {
              this.loadUserInfoBySso(data).then(() => {
                if (this.user.id && this.destination) {
                  window.location = this.destination
                } else {
                  this.$router.replace({ name: 'Index' }).catch()
                }
              })
            } else {
              console.log(`jsonp-error`, err)
            }
          }
        )
      }
    },
    async receiveMessage(event) {
      if (!event.data || typeof event.data !== 'string') {
        return
      }
      const origin = event.origin
      if (origin !== process.env.VUE_APP_GJW_PORTAL_URL) {
        return
      }
      const data = JSON.parse(event.data) || {}
      if (data.login) {
        // 获取用户信息
        if (await this.checkLogin(data.token)) {
          const anchor = localStorage.getItem('anchor')
          if (anchor && anchor.includes('inviteLink')) {
            location.href = localStorage.getItem('anchor')
            return
          }
          const to = Utils.getUrlQuery('to')
          if (to && ['OpenSpaceList'].includes(to)) {
            this.$router.replace({ name: to, query: { to: to }}).catch()
          } else {
            this.$router.replace({ name: 'Index' }).catch()
          }
        }
      }
      // 打开外链
      if (data.openLink) {
        this.openUrl(data.url)
      }
    },
    toHelp() {
      const url = this.introUrl
      if (!url) { return }
      if (this.platform === 'web') {
        window.open(url, '_blank')
      } else {
        this.$desktopClient.NavigateToBrowser(url)
      }
    }
  },

  head() {
    return {
      title: '数维构件坞 - 登录',
    }
  },
}
</script>

<style lang="less" scoped>
.gjw-signin-page {
  height: 100%;
  padding: 0 0;
  box-sizing: border-box;
  background-image: url("~@/assets/img/login-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  .sign-in-title {
    text-align: center;
    margin-bottom: 28px;
  }
  #userInfoIframe {
    margin-bottom: 64px;
  }
  .footer-container {
    width: 100vw;
    height: 72px;
    background: @color-grey-darkest;
    color: @color-fill-white;
    line-height: 72px;
    text-align: center;
    position: fixed;
    bottom: 0;
    z-index: 999;
  }
  .huo-dong-tu{
    width: 500px;
    height:100px;
    cursor: pointer;
    margin-top: -90px;
  }
}
</style>
